import { call, select, retry, put } from "redux-saga/effects"
import { storeApiLoading } from "actions"
import { getToken } from "sagas/DAuth"

export function* callApi(api, params = {}) {
  try {
    yield put(storeApiLoading(true))
    const { payload, error } = yield retry(3, 1, execApi, api, params)
    if (payload && !error) {
      return { payload }
    }
    throw Error(error)
  } catch (error) {
    return { error }
  } finally {
    yield put(storeApiLoading(false))
  }
}

export const getJwtSelecter = state => state.dAuth.jwt
export function* execApi(api, params) {
  const { tokenRefreshError, jwt } = yield call(
    getToken,
    yield select(getJwtSelecter)
  )

  if (tokenRefreshError && !jwt) {
    // retry処理を実行させたくないためreturnしている
    return { error: tokenRefreshError.message }
  }

  const { payload, error } = yield call(api, { params, jwt })
  if (payload && !error) {
    return { payload }
  }
  throw Error(error)
}
